import type { SupportedRoute } from "@/hooks/deepLinking/useDeepLinkRouting";

type DeepLinkRouteConfig = Record<SupportedRoute, boolean>;

interface FeatureFlags {
  appMinimumSupportedVersion?: string;
  appVideoResourcesPrefixUrl: string;
  configureDeepLinkRoutes: DeepLinkRouteConfig;
  isAddToCalendarEnabled: boolean;
  isAndroidSecurityScreenDisabled: boolean;
  isAssignAssessmentsToProxySupportsEnabled: boolean;
  isBaselineAssessmentsEnabled: boolean;
  isGroupClassRedesignEnabled: boolean;
  isMyEquipV2LoginEnabled: boolean;
  isOnboardingV2Enabled: boolean;
}

const LDFlags: Record<keyof FeatureFlags, string> = {
  appMinimumSupportedVersion: "mobile-minimum-version",
  appVideoResourcesPrefixUrl: "app-video-resources-prefix-url",
  configureDeepLinkRoutes: "configure-mobile-deep-link-routes",
  // https://teamequip.atlassian.net/browse/PT-1441
  // https://teamequip.atlassian.net/browse/MR-2
  isAddToCalendarEnabled: "enabled-calendar-integration-mobile",
  isAndroidSecurityScreenDisabled: "disable-android-security-screen",
  isAssignAssessmentsToProxySupportsEnabled:
    "assign-assessments-to-proxy-supports",
  isBaselineAssessmentsEnabled: "baseline-assessments",
  isGroupClassRedesignEnabled: "group-class-redesign-enabled",
  isMyEquipV2LoginEnabled: "my-equip-v2-login-enabled",
  isOnboardingV2Enabled: "onboarding-v2-enabled",
};

// Default configuration for deep link routes
// Existing routes (/schedule, /video-content) are enabled by default
// New routes start disabled until explicitly enabled via LaunchDarkly
/* eslint-disable @typescript-eslint/naming-convention -- route paths are not boolean properties */
const defaultDeepLinkRouteConfig: DeepLinkRouteConfig = {
  "/explore": false,
  "/home": false,
  "/journal": false,
  "/messages": false,
  "/profile": false,
  "/schedule": true,
  "/video-content": true,
};
/* eslint-enable @typescript-eslint/naming-convention */

export type { DeepLinkRouteConfig, FeatureFlags };
export { defaultDeepLinkRouteConfig, LDFlags };
